export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14497.1628eb86.jpg";